import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

import { CertificateCongratulations } from '@/certificate/components/CertificateCongratulations/CertificateCongratulations'
import {
  FEATURE_MODULAR_DASHBOARD,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_AI,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_DIGITALIZATION,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_FUNDAMENTALS_OF_DIGITALIZATION_2_0,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_LEADERSHIP,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_PROJECT_MANAGEMENT,
} from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import useFeatures from '@/core/utils/features/useFeatures'
import CourseGenericOverview from '@/course-generic/components/CourseGenericOverview/CourseGenericOverview'
import DashboardMain from '@/dashboard/components/DashboardMain/DashboardMain'
import LearnpathsDashboardModalFinish from '@/learnpaths-assigned-dashboard/components/LearnpathsDashboardModalFinish/LearnpathsDashboardModalFinish'
import LearnpathsDashboardModalInvite from '@/learnpaths-assigned-dashboard/components/LearnpathsDashboardModalInvite/LearnpathsDashboardModalInvite'

import { HomeOverviewGradientBackdrop } from './-components/HomeOverviewGradientBackdrop'
import { HomeOverviewModularDashboard } from './-components/HomeOverviewModularDashboard'

const searchSchema = v.object({
  'certificate-congratulations': v.optional(v.string()),
  'learningpath-finished': v.optional(v.string()),
  'learningpath-invite': v.optional(v.string()),
})

export const Route = createFileRoute('/_learning/home/_overview')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-home',
        }),
      },
    ],
  }),
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { 'learningpath-invite': sharingLinkId = '' } = Route.useSearch()
  const hasModularDashboard = useFeatures(FEATURE_MODULAR_DASHBOARD)
  const hasStartRouteSignatureCourseDigitalization = useFeatures(
    FEATURE_START_ROUTE_SIGNATURE_COURSE_DIGITALIZATION,
  )
  const hasStartRouteSignatureCourseAi = useFeatures(
    FEATURE_START_ROUTE_SIGNATURE_COURSE_AI,
  )
  const hasStartRouteSignatureCourseProjectManagement = useFeatures(
    FEATURE_START_ROUTE_SIGNATURE_COURSE_PROJECT_MANAGEMENT,
  )
  const hasStartRouteSignatureCourseLeadership = useFeatures(
    FEATURE_START_ROUTE_SIGNATURE_COURSE_LEADERSHIP,
  )
  const hasStartRouteSignatureCourseFundamentalsOfDigitalization = useFeatures(
    FEATURE_START_ROUTE_SIGNATURE_COURSE_FUNDAMENTALS_OF_DIGITALIZATION_2_0,
  )

  if (sharingLinkId) {
    return <LearnpathsDashboardModalInvite />
  }

  if (hasStartRouteSignatureCourseDigitalization) {
    return <CourseGenericOverview courseSlug="digital-transformation" />
  }
  if (hasStartRouteSignatureCourseAi) {
    return <CourseGenericOverview courseSlug="ai-fundamentals" />
  }
  if (hasStartRouteSignatureCourseProjectManagement) {
    return <CourseGenericOverview courseSlug="project-management" />
  }
  if (hasStartRouteSignatureCourseLeadership) {
    return <CourseGenericOverview courseSlug="leadership" />
  }
  if (hasStartRouteSignatureCourseFundamentalsOfDigitalization) {
    return (
      <CourseGenericOverview courseSlug="fundamentals-of-digitalization-2-0" />
    )
  }

  if (hasModularDashboard) {
    return (
      <>
        <HomeOverviewGradientBackdrop>
          <HomeOverviewModularDashboard />
        </HomeOverviewGradientBackdrop>
        <CertificateCongratulations />
        <LearnpathsDashboardModalFinish />
      </>
    )
  }

  return (
    <>
      <DashboardMain />
      <CertificateCongratulations />
      <LearnpathsDashboardModalFinish />
    </>
  )
}
